// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myChart-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(25vw, 1fr));
  gap: 1rem;
  padding: 1rem;
  width: 80vw;
  margin-top: 3vh;
  margin-bottom: 3vh;
  align-items: center;
  justify-items: center;
}

.chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.myChart-header {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 0.5rem;
}

.myChart-canvas,
.barChart-canvas {
  width: 100%;
  height: auto;
}

/* Styles for horizontal bar chart */
.barChart-canvas {
  max-height: 400px;
}

/* Responsive design for medium-sized devices */
@media (max-width: 991px) {
  .myChart-container {
    /* width: 100vw; */
    grid-template-columns: repeat(auto-fill, minmax(50vw, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/AdminCharts.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;EACE;IACE,kBAAkB;IAClB,2DAA2D;EAC7D;AACF","sourcesContent":[".myChart-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(25vw, 1fr));\n  gap: 1rem;\n  padding: 1rem;\n  width: 80vw;\n  margin-top: 3vh;\n  margin-bottom: 3vh;\n  align-items: center;\n  justify-items: center;\n}\n\n.chart-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background-color: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.myChart-header {\n  font-size: 1.5rem;\n  color: #333;\n  margin-bottom: 0.5rem;\n}\n\n.myChart-canvas,\n.barChart-canvas {\n  width: 100%;\n  height: auto;\n}\n\n/* Styles for horizontal bar chart */\n.barChart-canvas {\n  max-height: 400px;\n}\n\n/* Responsive design for medium-sized devices */\n@media (max-width: 991px) {\n  .myChart-container {\n    /* width: 100vw; */\n    grid-template-columns: repeat(auto-fill, minmax(50vw, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
